<template>
    <div>
        <b-row>
            <b-table 
                responsive
                :fields="fields" 
                striped hover  
                :items="productos">
                <template v-slot:cell(referencia)="data">
                    <b-row>
                        <b-col class="col-sm-2 d-none d-sm-block">
                            <b-img :src="data.item.imagen" alt="Image 1" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                        </b-col>
                        <b-col cols="12" md="9">
                            <div>
                                {{ data.item.nombre_item }}
                            </div>
                            <div>
                                <b>Item:</b> {{ data.item.referencia }}
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template v-slot:cell(valor_real_unit)="data">
                    $ {{numberFormat(data.item.valor_real_unit)}}
                </template>
                <template v-slot:cell(personalized_discount)="data">
                    {{data.item.personalized_discount}} %
                </template>
                <template v-slot:cell(porcentaje_impuesto)="data">
                    {{data.item.porcentaje_impuesto}} %
                </template>
                <template v-slot:cell(subtotal_items)="data">
                    $ {{ numberFormat(data.item.subtotal_items) }}
                </template>
            </b-table>
        </b-row>
        <hr>
        <b-row align-h="between">
            <b-col cols="12" md="6">
                <div class="pb-4"><b>Comentario de la Orden:</b></div>
                <div v-if="datos.comentario !== null">
                    {{datos.comentario}}
                </div>
                <div v-else>
                    Sin comentarios.
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th class="text-end">Subtotal Bruto:</th>
                            <td><b>$ {{numberFormat(datos.subtotal_bruto)}}</b></td>
                        </tr>
                        <tr v-if="datos.descuento > 0">
                            <th class="text-end">Descuento:</th>
                            <td><b>$ {{numberFormat(datos.descuento)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">Subtotal Neto:</th>
                            <td><b>$ {{numberFormat(datos.subtotal_neto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">IVA:</th>
                            <td><b>$ {{numberFormat(datos.impuesto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end blue--text">Monto Total:</th>
                            <td class="blue--text"><b>$ {{numberFormat(datos.total_precio)}}</b></td>
                        </tr>

                    </tbody>
                </table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        productos: {
            type: Array
        },
        datos: {
            type: Object
        }
    },
    data(){
        return{
            fields: [
                { key: 'referencia', label: 'Item', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'valor_real_unit', label: 'Vr. Unit', sortable: true},
                { key: 'personalized_discount', label: 'Descuento', sortable: true},
                { key: 'porcentaje_impuesto', label: 'Impuesto', sortable: true},
                { key: 'subtotal_items', label: 'Subtotal', sortable: true},
            ],
        }
    },
    
}
</script>